import { DATA_PROFILES, type DataProfile, dataProfile, profileKnown } from "./data-setup.ts";

// What kind of product this is, for what zooi offers it (docs/product-decisions.md
// 2026-10-31, 2026-11-01): the same eleven kinds the data setup uses. A type a
// person set wins, then a store listing's URL, then the categories of the first
// read, then a social profile's URL (a creator). A product may be an account a
// person grows, an X or TikTok profile, with no website or repository at all.

export const PRODUCT_KINDS = DATA_PROFILES;
export type ProductKind = DataProfile;
export const productKind = dataProfile;
/** Whether anything says what kind the product is; before that the kind is only the default. */
export const productKindKnown = profileKnown;

export { SOCIAL_HOSTS, SOCIAL_PLATFORMS, type SocialPlatform, isAccountOnly, isSocialHost, socialPlatformOf, socialProfile, TWITTERAPI_READ_RULES, xHandle, X_READ_RULES, X_READERS, type XReader, xReaderOf } from "./social.ts";
export { storeListingKind, type StoreKind } from "./stores.ts";

/**
 * The channels each kind of product usually grows on, most useful first; the
 * channel rules list these first for a product of that kind, and the rest stay
 * one click away. `all` rules apply everywhere.
 */
export const KIND_CHANNELS: Readonly<Record<ProductKind, readonly string[]>> = {
  open_source: ["github", "hackernews", "reddit", "stackexchange", "x", "discord", "bluesky", "mastodon", "devto", "producthunt", "linkedin"],
  developer_tool: ["hackernews", "reddit", "stackexchange", "x", "github", "devto", "discord", "linkedin", "producthunt", "youtube", "email"],
  saas: ["x", "linkedin", "reddit", "producthunt", "hackernews", "youtube", "email"],
  services: ["linkedin", "email", "x", "youtube"],
  consumer_app: ["app_store", "google_play", "tiktok", "instagram", "youtube", "x", "reddit", "discord", "xiaohongshu", "threads"],
  extension: ["chrome_web_store", "producthunt", "reddit", "x", "github", "youtube", "hackernews", "email"],
  website: ["directory", "reddit", "x", "pinterest", "youtube", "producthunt", "email"],
  commerce: ["instagram", "tiktok", "youtube", "pinterest", "xiaohongshu", "email"],
  marketplace: ["reddit", "linkedin", "x", "instagram", "email"],
  content: ["x", "tiktok", "youtube", "instagram", "threads", "bluesky", "xiaohongshu", "bilibili", "douyin", "weibo", "linkedin", "email"],
  local_service: ["google_business", "instagram", "xiaohongshu", "tiktok", "email"],
};

/** Whether a channel is one this kind of product usually grows on; `all` always is. */
export const channelFits = (kind: ProductKind, channel: string) => channel === "all" || KIND_CHANNELS[kind].includes(channel);

/** Whether a playbook suits a kind of product: one that names no kinds suits every product. */
export const playbookFits = (kinds: readonly string[], kind: ProductKind) => kinds.length === 0 || kinds.includes(kind);
